export * as actionCatalog from '@wix/auto_sdk_automations_action-catalog/meta';
export * as activationActionLog from '@wix/auto_sdk_automations_activation-action-log/meta';
export * as activationLog from '@wix/auto_sdk_automations_activation-log/meta';
export * as activationActionSummary from '@wix/auto_sdk_automations_activation-action-summary/meta';
export * as storageItem from '@wix/auto_sdk_automations_storage-item/meta';
export * as triggerCatalog from '@wix/auto_sdk_automations_trigger-catalog/meta';
export * as automationsService from '@wix/auto_sdk_automations_automations-service/meta';
export * as customTrigger from '@wix/auto_sdk_automations_custom-trigger/meta';
export * as activations from '@wix/auto_sdk_automations_activations/meta';
export * as automationsV2 from '@wix/auto_sdk_automations_automations-v-2/meta';
export * as automationTemplates from '@wix/auto_sdk_automations_automation-templates/meta';
